
import WebApp from '@twa-dev/sdk';

export function initTelegram(): void {
  if (WebApp.initData) {
    WebApp.ready();
    WebApp.expand();
    WebApp.enableClosingConfirmation();
  }
}

export function applyTelegramTheme(): void {
  const tp = WebApp.themeParams;
  const s = document.documentElement.style;
  const set = (k: string, v?: string) => v && s.setProperty(k, v);
  set('--tg-theme-bg-color',                tp.bg_color);
  set('--tg-theme-secondary-bg-color',      tp.secondary_bg_color);
  set('--tg-theme-text-color',              tp.text_color);
  set('--tg-theme-hint-color',              tp.hint_color);
  set('--tg-theme-link-color',              tp.link_color);
  set('--tg-theme-button-color',            tp.button_color);
  set('--tg-theme-button-text-color',       tp.button_text_color);
  set('--tg-theme-accent-text-color',       tp.accent_text_color);
  set('--tg-theme-header-bg-color',         tp.header_bg_color);
  set('--tg-theme-section-bg-color',        tp.section_bg_color);
  set('--tg-theme-destructive-text-color',  tp.destructive_text_color);
}

export function haptic(type: 'light' | 'medium' | 'heavy' = 'light'): void {
  WebApp.HapticFeedback?.impactOccurred(type);
}

export function showMainButton(text: string, cb: () => void): void {
  WebApp.MainButton.setText(text);
  WebApp.MainButton.onClick(cb);
  WebApp.MainButton.show();
}
export function hideMainButton(): void { WebApp.MainButton.hide(); }
export function showBackButton(cb: () => void): void {
  WebApp.BackButton.onClick(cb);
  WebApp.BackButton.show();
}
export function hideBackButton(): void { WebApp.BackButton.hide(); }

export default WebApp;
